export const createRoleState = () => ({
    name: '',
    permissions: [],
    kinds: [],
});
